import React, { useRef } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import FormTip from './FormTip';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  addTip: {
    minHeight: '60px',
  }
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function TipDialogs(props) {
 
  const formTipRef = useRef();
  const [open, setOpen] = React.useState(false);


  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const onClickSaveButton = (e) => {
    e.preventDefault()


    formTipRef.current.handleSubmitFromParent(e)

    // props.updateDataAction(e)
  }




  return (
    <>
      <div style={{minHeight:'60px'}}>
      <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        Add new Health Tip
      </Button>
      </div>

      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} disableBackdropClick={false}>
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Add New Health Tip
        </DialogTitle>
        <DialogContent dividers>
          <FormTip ref={formTipRef} />


        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => { onClickSaveButton(e) }} color="primary">
            Save changes
          </Button>
          <Button onClick={handleClose} >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}